import React from 'react';
import axios from 'axios'
import { connect } from 'react-redux'
import { showAlertModal } from '../../../../actions'
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';
import BasicInfo from './BasicInfo';
import RightsSelect from './RightsSelect';
import AccessSelect from './AccessSelect';
import ViewSelect from './ViewSelect';

// bRole: 1: master admin, 2: local admin, 3: view only

class UserForm extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      bID: '',
      name: '',
      email: '',
      password: '',
      access: [],
      userviews: [],
      customerId: 'none',
      customerName: '',
      bRole: 3,
      userEdit: false,
      generatePassword: 1,
      passwordVisible: false,
      sendCredentials: true,
    };

  }

  componentDidMount(){
    if (this.props.user && this.props.user.bID && this.props.user.bRole){
      // we are editing a current user
      this.setState({
        bID: this.props.user.bID,
        userEdit: true,
        name: this.props.user.sDescription || '',
        email: this.props.user.sName,
        password: this.props.user.sPassword.substring(0,20),
        access: this.props.user.access &&  this.props.user.access.length > 0 ? this.props.user.access.map(a => a.bProjectID.toString()) : [], // just need an array of project/site ids here
        userviews: this.props.user.sViews &&  this.props.user.sViews.length > 2 ? JSON.parse(this.props.user.sViews) : [],
        customerId: this.props.user.bCustomerID,
        customerName: this.props.user.sCustomerName,
        bRole: this.props.user.bRole,
        generatePassword: 0,
        passwordVisible: false,
        sendCredentials: false,
      })
    };
  }

  componentDidUpdate() {
    if (this.props.user && this.props.user.bID !== this.state.bID) {
      this.setState({
        bID: this.props.user.bID,
        userEdit: true,
        name: this.props.user.sDescription || '',
        email: this.props.user.sName,
        password: this.props.user.sPassword.substring(0,20),
        access: this.props.user.access &&  this.props.user.access.length > 0 ? this.props.user.access.map(a => a.bProjectID.toString()) : [], // just need an array of project/site ids here
        userviews: this.props.user.sViews &&  this.props.user.sViews.length > 2 ? JSON.parse(this.props.user.sViews) : [],
        customerId: this.props.user.bCustomerID,
        customerName: this.props.user.sCustomerName,
        bRole: this.props.user.bRole,
        generatePassword: 0,
        passwordVisible: false,
        sendCredentials: false,
      })
    }
  }

  undoEdit = () => {
    // revert changes to user edit
    this.setState({
      bID: this.props.user && this.props.user.bID ? this.props.user.bID : '',
      userEdit: true,
      name: this.props.user.sDescription || '',
      email: this.props.user.sName,
      password: this.props.user.sPassword.substring(0,20),
      access: this.props.user.access &&  this.props.user.access.length > 0 ? this.props.user.access.map(a => a.bProjectID.toString()) : [], // just need an array of project/site ids here
      userviews: this.props.user.sViews &&  this.props.user.sViews.length > 2 ? JSON.parse(this.props.user.sViews) : [],
      customerId: this.props.user.bCustomerID,
      customerName: this.props.user.sCustomerName,
      bRole: this.props.user.bRole,
      generatePassword: 0,
      passwordVisible: false,
      sendCredentials: false,
    });
  };

  handleChange = (e, type) => {
    let state = { [type]: e.target.value }

    if (type === 'sendCredentials') {
      state.sendCredentials = e.target.checked
    }

    if (type === 'customerId') {
      state.access = []
      state.userviews = []
      let targetCustomer = this.props.customers.find(customer => customer.bID === parseInt(e.target.value));

      if (targetCustomer) {
        state.customerName = targetCustomer.sName

        // if customer is Dividia, force change to master admin, else reset to ensure no dangling master admin on change of customer
        if (targetCustomer.bID === 1) {
          state.bRole = 1
        } else if (this.state.bRole === 1) {
          state.bRole = 3
        }
      }
    }

    this.setState(state)
  };

  handleRightsChange = (role) => {
    let state = { bRole: role, access: [], userviews: [] }

    // if bRole = master admin, force change customer to Dividia, else reset to ensure no dangling Dividia user for non-master admin roles
    if (role === 1) {
      const customer = this.props.customers.find(customer => customer.bID === 1)
      state.customerId = customer.bID
      state.customerName = customer.sName
    } else if (parseInt(this.state.customerId) === 1) {
      state.customerId = 'none'
      state.customerName = 'None'
    }

    this.setState(state)
  };

  handleEmailConfirmationChange = () => {
    this.setState({ sendConfirmationEmail: !this.state.sendConfirmationEmail });
  };

  setGeneratePassword = (generate) => {
    this.setState({ generatePassword: generate })
  }

  togglePasswordVisible = () => {
    this.setState({ passwordVisible: !this.state.passwordVisible })
  };

  resetPassword = async (value) => {
    this.setState({password: value.substring(0, 20)})
    this.updateUserData(this.state.bID, value)
  }

  handleAccessChange = (e) => {
    let siteId = e.target.value;
    let viewsArray = this.state.userviews.slice();
    // this will edit JSAcl table

    if(siteId === 'all'){
      // may need to add all site ids to the access array
      let idArray = this.props.sites.map(s => s.bId.toString());
      this.setState({
        hasAllAccess: this.state.hasAllAccess ? false : true,
        access: this.state.hasAllAccess ? [] : idArray
      })
      return;
    };

    let accessArray = this.state.access.slice();

    if(accessArray.includes(siteId)){
      // find it and remove it
      let targetIndex = accessArray.indexOf(siteId);
      if(targetIndex > -1){
        accessArray.splice(targetIndex,1);
        // also remove any views in this.state.userviews that were using this bProjectID
        viewsArray.forEach( v => {
          let targetView = this.props.views.find(view => view.bID === v);
          if(targetView.bProjectID === parseInt(siteId)){
            // remove this view from userviews
            viewsArray = viewsArray.filter(view => view !== targetView.bID);

          }
        })
      };
    } else {
      // add it to our temp access array
      accessArray.push(siteId);
    };

    this.setState({ access: accessArray, userviews: viewsArray });

  };

  handleViewChange = (e) => {
    // add/remove the view as well as the sites for which the cameras within the selected view belongs to
    let viewId = parseInt(e.target.value)
    let viewsArray = [...this.state.userviews]

    // if value is already in userviews, remove it - otherwise add it
    if(viewsArray.includes(viewId)){
      viewsArray = viewsArray.filter(v => v !== viewId)
    } else {
      viewsArray.push(viewId)

      // get the cameras in the view
      let view = this.props.views.find(v => v.bID === viewId)
      let cams = view && view.sCams ? JSON.parse(view.sCams) : []
      let accessArray = [...this.state.access]

      // get the sites for each camera
      cams.forEach(c => {
        let cam = this.props.cameras.find(ca => ca.bID === c)
        let device = cam && this.props.devices.find(d => d.sDeviceID === cam.sDeviceID)
        let siteId = device && device.bCustomerProjectID.toString()

        if (siteId && !accessArray.includes(siteId)) {
          accessArray.push(siteId)
        }
      })
      this.setState({access: accessArray})
    }

    this.setState({ userviews: viewsArray });
  };

  onSubmit = async() => {
      // join this.state.access into comma seperated string
      // if there are no rights they wont have access to anything, if there is no sites specified they will not have acceess
      if (this.state.name.trim() === '' || this.state.email.trim() === '' || this.state.customerId === 'none'
        || (!this.state.userEdit && !this.state.generatePassword && this.state.password.trim() === '')) { // only check password if we are manually setting password in new user form
        this.props.showAlertModal(['WARNING', 'Please fill in all details.'])
        return
      }

      if (this.state.access.length < 1) {
        this.props.showAlertModal(['WARNING', 'User must be given access to at least 1 site. If site is not available, please verify it has been created prior to creating the user.'])
        return;
      }

      if (this.state.userviews.length < 1) {
        this.props.showAlertModal(['WARNING', 'User must be given access to at least 1 view.'])
        return;
      }

      const reqBody = {
        "id": this.state.userEdit ? this.props.user.bID : null,
        "email": this.state.email.trim(),
        "password": this.state.password.substring(0,1) === '*' ? this.props.user.sPassword : this.state.password,
        "generatePassword": this.state.generatePassword,
        "customerId": this.state.customerId,
        "views": JSON.stringify(this.state.userviews),
        "role": this.state.bRole,
        "description": this.state.name,
        "access": JSON.stringify(this.state.access.map(a => parseInt(a))),
        "sendCredentials": this.state.sendCredentials,
      };

      await axios({
        method: 'post',
        url: this.props.cloudAPI + 've/user?device=' + this.props.deviceList[0],
        headers: {
          'Content-Type': 'Application/json',
          'Authorization': 'Bearer ' + this.props.token
        },
        withCredentials: true,
        data: reqBody,

      }).then(response => {
        // insert returns new id in response.data.data[0], update returns null in response.data.data[0]
        this.props.showAlertModal(['SUCCESS', 'User details successfully saved.'])
        this.updateUserData((this.state.userEdit) ? this.props.user.bID : response.data.data[0], null)
        !this.state.userEdit && this.props.closeForm()

      }).catch(error => {
        if (error.response.data.error === 'duplicate') {
          this.props.showAlertModal(['ERROR', 'Email already exists.'])
          return
        }
        this.props.showAlertModal(['ERROR', 'Unable to save user details.'])
      })
  }

  updateUserData = (userid, resetpassword) => {
    let data = {
      bID: userid,
      sDescription: this.state.name,
      sName: this.state.email,
      sPassword: this.state.password,
      fChangePassword: this.state.userEdit ? this.props.fChangePassword : 1,
      bCustomerID: parseInt(this.state.customerId),
      sCustomerName: this.state.customerName,
      bRole: this.state.bRole,
      access: this.props.sites.filter(val => this.state.access.includes(val.bID.toString())).map(data => ({bProjectID: data.bID, sProjectName: data.sName, sCustomerName: data.sCustomerName})),
      sViews: JSON.stringify(this.state.userviews),
    }

    if (resetpassword) {
      data.sPassword = resetpassword
      data.fChangePassword = 1
    }

    this.props.updateData('user', data)
  }

  promptDeleteUser = () => {
    if(!this.props.user || !this.props.user.bID){
      return;
    };

    if(this.props.user.bID === this.props.userData.bID){
      this.props.showAlertModal(['WARNING', 'You may not delete your own user account.'])
      return;
    };

    this.setState({ showDeleteUserPrompt: true });
  };

  deleteUser = async (user) => {
    const reqBody = {
      "id": this.props.user.bID,
      "del": 1,
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + `ve/user?device=` + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'User successfully deleted.'])
      this.props.updateData('user', {}, true)
      this.props.closeForm();

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['WARNING', 'Unable to delete user.'])
      this.setState({ showDeleteUserPrompt: false })
    })
  }

  onBlur = (e) => {
    if (this.props.user) {
      const access = this.props.user.access &&  this.props.user.access.length > 0 ? this.props.user.access.map(a => a.bProjectID.toString()) : []
      const views = this.props.user.sViews &&  this.props.user.sViews.length > 2 ? JSON.parse(this.props.user.sViews) : []

      if ((this.state.name !== this.props.user.sDescription)
        || (this.state.email !== this.props.user.sName)
        || (this.state.password !== this.props.user.sPassword.substring(0,20))
        || (parseInt(this.state.customerId) !== parseInt(this.props.user.bCustomerID))
        || (this.state.bRole !== this.props.user.bRole)
        // for arrays/objects, make sure to parse, sort and stringify before comparing as equality comparison does not compare properly on multi-level data
        || (JSON.stringify(this.state.access.sort()) !== JSON.stringify(access.sort()))
        || (JSON.stringify(this.state.userviews.sort()) !== JSON.stringify(views.sort()))) {
          this.props.onBlur(e, this.onSubmit)
      }

    // new
    } else {
      if (this.state.name.trim() !== '' || this.state.email.trim() !== '' || this.state.password.trim() !== ''
        || this.state.customerId !== 'none' || parseInt(this.state.bRole) !== 3 || this.state.access.length > 1 || this.state.userviews.length > 1) {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    return (
      <FormWrapper heading={this.state.userEdit ? "Edit User" : "New User"}
                   onBlur={this.onBlur}
                   closeForm={this.props.closeForm}
                   onSubmit={this.onSubmit}
                   onDelete={this.state.bID !== 1 && this.promptDeleteUser}
                   edit={this.state.userEdit}
                   undoEdit={this.undoEdit} >

        {/* upper container */}
        <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: "1vmin" }}>

          <BasicInfo
            userId={this.state.bID}
            userEdit={this.state.userEdit}
            handleChange={this.handleChange}
            name={this.state.name}
            email={this.state.email}
            password={this.state.password}
            generatePassword={this.state.generatePassword}
            setGeneratePassword={this.setGeneratePassword}
            passwordVisible={this.state.passwordVisible}
            togglePasswordVisible={this.togglePasswordVisible}
            sendCredentials={this.state.sendCredentials}
            resetPassword={this.resetPassword}
            customers={this.props.customers}
            customerId={this.state.customerId} />

         <RightsSelect
            bRole={this.state.bRole}
            handleRightsChange={this.handleRightsChange}
            userEdit={this.state.userEdit}
            userData={this.props.userData} />

        </div>

        <hr />

        {/* lower container */}
        {this.state.customerId && this.state.customerId !== 'none' &&
            <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: "1vmin" }}>

              <AccessSelect
                bRole={this.state.bRole}
                sites={this.props.sites}
                customers={this.props.customers}
                handleAccessChange={this.handleAccessChange}
                access={this.state.access}
                userEdit={this.state.userEdit}
                user={this.props.user}
                customerId={this.state.customerId} />

              <ViewSelect
                bRole={this.state.bRole}
                views={this.props.views}
                sites={this.props.sites}
                customers={this.props.customers}
                handleViewChange={this.handleViewChange}
                access={this.state.access}
                userEdit={this.state.userEdit}
                user={this.props.user}
                userviews={this.state.userviews}
                customerId={this.state.customerId} />

            </div>
        }

        { this.state.showDeleteUserPrompt &&
          <Dialog
            boxStyle={{width: '50vmin'}}
            title="WARNING"
            content={
              <div>
                <p>Are you sure you want to delete this user?</p>
                <p>{this.props.user.sName}</p>
                <p>This action cannot be undone.</p>
              </div>
            }
            buttons={[
              {label: 'Delete', onClick: () => this.deleteUser(this.props.user)},
              {label: 'Cancel', onClick: () => this.setState({ showDeleteUserPrompt: false })},
            ]}
          />
        }
      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
export default connect(mapStateToProps, { showAlertModal } )(UserForm)